import { AllDocumentTypes, InterconnectionAgreementDocumentType } from 'types';

import FormSection from '../Forms/FormSection';
import { InterconnectionAgreementDescription } from '../InstallMilestonePackage/InstallationFormSectionDescriptions';

import { DocumentList } from './Documents/DocumentList';

type UtilityBillProps = {
  allowArchive?: boolean;
  account: any;
  showCheckboxes?: boolean;
  checkboxCategories?: AllDocumentTypes[];
  isPackageEditable?: boolean;
};

export const ApprovedInterconnectionAgreement = ({
  allowArchive,
  account,
  showCheckboxes = false,
  checkboxCategories = [],
  isPackageEditable = true,
}: UtilityBillProps) => {
  const isCA = account?.address?.state === 'CA';

  return isCA ? (
    <FormSection title="Approved Interconnection Agreement" description={InterconnectionAgreementDescription()}>
      <DocumentList
        documentTypeFilter={[InterconnectionAgreementDocumentType.interconnectionAgreement]}
        title="Approved Interconnection Agreement"
        showTypeLabelOnItems={false}
        baseCategory={'Interconnection Agreement'}
        allowArchive={allowArchive}
        showCheckboxes={showCheckboxes}
        checkboxCategories={checkboxCategories}
        isPackageEditable={isPackageEditable}
      />
    </FormSection>
  ) : null;
};
